import { render, staticRenderFns } from "./AuthorizationModal.vue?vue&type=template&id=400693e0&scoped=true&"
import script from "./AuthorizationModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizationModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationModal.vue?vue&type=style&index=0&id=400693e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400693e0",
  null
  
)

export default component.exports